var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInProgressIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_12995",
    "data-name": "Grupo 12995",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 47.232,
    height: 47.28,
    viewBox: "0 0 47.232 47.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4267",
    "data-name": "Rect\\xE1ngulo 4267",
    width: 47.232,
    height: 47.28,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12267",
    "data-name": "Grupo 12267",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_858",
    "data-name": "Trazado 858",
    d: "M36.331,13.646a1.229,1.229,0,0,1-1.124-.732q-.352-.8-.769-1.562A1.228,1.228,0,0,1,36.6,10.178q.464.851.857,1.743a1.229,1.229,0,0,1-1.122,1.725",
    transform: "translate(7.82 2.175)",
    fill: "#6f2fd3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_859",
    "data-name": "Trazado 859",
    d: "M26.269,42.567a1.229,1.229,0,0,1-.458-2.369,21.113,21.113,0,0,0,3.039-1.514,1.228,1.228,0,1,1,1.269,2.1,23.807,23.807,0,0,1-3.393,1.691,1.223,1.223,0,0,1-.457.088m6.137-3.7a1.227,1.227,0,0,1-.795-2.164,21.676,21.676,0,0,0,2.411-2.4,1.228,1.228,0,0,1,1.864,1.6A24.089,24.089,0,0,1,33.2,38.576a1.227,1.227,0,0,1-.795.291m4.662-5.439a1.229,1.229,0,0,1-1.048-1.869,21.135,21.135,0,0,0,1.533-3.032,1.228,1.228,0,0,1,2.274.928,23.694,23.694,0,0,1-1.711,3.385,1.226,1.226,0,0,1-1.049.588m2.708-6.635a1.247,1.247,0,0,1-.276-.032,1.227,1.227,0,0,1-.922-1.471,21.123,21.123,0,0,0,.491-3.361,1.228,1.228,0,0,1,2.451.16,23.6,23.6,0,0,1-.549,3.752,1.227,1.227,0,0,1-1.195.953m.467-7.15a1.23,1.23,0,0,1-1.222-1.114,21.161,21.161,0,0,0-.586-3.345,1.228,1.228,0,1,1,2.376-.618,23.766,23.766,0,0,1,.656,3.735,1.229,1.229,0,0,1-1.109,1.337c-.039,0-.077,0-.115,0",
    transform: "translate(5.71 3.112)",
    fill: "#6f2fd3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_860",
    "data-name": "Trazado 860",
    d: "M21.977,38.846a1.228,1.228,0,0,1-.165-2.445c.578-.079,1.151-.182,1.713-.307a1.228,1.228,0,0,1,.533,2.4q-.941.21-1.915.344a1.285,1.285,0,0,1-.167.011",
    transform: "translate(4.732 8.225)",
    fill: "#6f2fd3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_861",
    "data-name": "Trazado 861",
    d: "M26.346,22.3h-6.14V12.478a1.228,1.228,0,0,0-2.456,0V23.531a1.229,1.229,0,0,0,1.228,1.228h7.368a1.228,1.228,0,1,0,0-2.456",
    transform: "translate(4.048 2.566)",
    fill: "#6f2fd3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_862",
    "data-name": "Trazado 862",
    d: "M43.848,5.093A1.228,1.228,0,0,0,41.409,4.8L41.07,7.672A23.64,23.64,0,1,0,23.64,47.28a1.228,1.228,0,1,0,0-2.456,21.184,21.184,0,1,1,14.8-36.341l-1.623-.309a1.228,1.228,0,1,0-.461,2.413l5.4,1.028c.015,0,.028,0,.044,0s.026.012.042.014a1.215,1.215,0,0,0,.2-.016,1.309,1.309,0,0,0,.241-.02,1.253,1.253,0,0,0,.221-.1,1.1,1.1,0,0,0,.2-.1,1.155,1.155,0,0,0,.168-.169,1.116,1.116,0,0,0,.15-.173,1.178,1.178,0,0,0,.092-.226,1.24,1.24,0,0,0,.076-.187c0-.015,0-.028,0-.044s.011-.026.014-.041Z",
    fill: "#6f2fd3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInProgressIcon);
export default __webpack_public_path__ + "static/media/inProgressIcon.56fb0a34096c67387094c4b4dc831720.svg";
export { ForwardRef as ReactComponent };